<template>
	<div>
		<div class="sf-datatable-wrapper">
			<div class="sf-datatable-container">
				<div class="sf-table">
					<table class="qms-table">
						<tbody>
							<tr>
								<!-- 조치처 -->
								<th class="col-1">{{ getMessage_('QWCC001460') }}</th>
								<td class="col-2">
									<!-- <el-input
										:value="popupSearchParams.rcpt"
										@input="value => setPopupSearchParams_({ key: 'rcpt', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/> -->
									<el-input
										:value="this.detailForm.rcptNm"
										@input="value => setDetailForm({ key: 'rcptNm', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/>
									<span class="unit input-icon" v-if="!setDisabled" @click="() => openUserPopup('rcpt')">
										<i class="icon-sf-search" />
									</span>
								</td>
								<td class="qms-apcn-tag" colspan="5">
									<div class="d-flex" style="text-align: left !important; overflow-x: auto; overflow-y: hidden">
										<el-tag
											:key="idx"
											v-for="(tag, idx) in rcptTag"
											:closable="!setDisabled"
											:disable-transitions="false"
											@close="handleClose(tag, idx, 'rcpt')"
										>
											{{ tag }}
										</el-tag>
										<template v-if="!setDisabled">
											<el-input
												class="input-new-tag"
												v-if="rcptVisible"
												v-model="rcptValue"
												ref="saveRcptInput"
												size="mini"
												@keyup.enter.native="handleRcptInputConfirm"
												@blur="handleRcptInputConfirm"
											>
											</el-input>
											<el-button v-else class="button-new-tag" @click="showRcptInput">+ {{ getMessage_('QWCC001492') }}</el-button>
										</template>
									</div>
								</td>
								<!-- 결재 -->
								<th class="col-1" rowspan="4" style="writing-mode: tb-rl">
									{{ getMessage_('QWCC001925') }}
								</th>
								<!-- 작성 -->
								<th class="col-1">{{ getMessage_('QWCC000056') }}</th>
								<!-- 검토 -->
								<th class="col-1">{{ getMessage_('QWCC000048') }}</th>
							</tr>
							<tr>
								<!-- 참조처 -->
								<th>{{ getMessage_('QWCC001847') }}</th>
								<td class="col-2">
									<el-input
										:value="this.detailForm.rcptBcNm"
										@input="value => setDetailForm({ key: 'rcptBcNm', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/>
									<span class="unit input-icon" @click="() => openUserPopup('rcptBc')" v-if="!setDisabled">
										<i class="icon-sf-search" />
									</span>
								</td>
								<td class="qms-apcn-tag" colspan="5">
									<div class="d-flex" style="text-align: left !important; overflow-x: auto; overflow-y: hidden">
										<el-tag
											:key="idx"
											v-for="(tag, idx) in rcptBcTag"
											:closable="!setDisabled"
											:disable-transitions="false"
											@close="handleClose(tag, idx, 'rcptBc')"
										>
											{{ tag }}
										</el-tag>
										<template v-if="!setDisabled">
											<el-input
												class="input-new-tag"
												v-if="rcptBcVisible"
												v-model="rcptBcValue"
												ref="saveRcptBcInput"
												size="mini"
												@keyup.enter.native="handleRcptBcInputConfirm"
												@blur="handleRcptBcInputConfirm"
											>
											</el-input>
											<el-button v-else class="button-new-tag" @click="showRcptBcInput">+ {{ getMessage_('QWCC001492') }}</el-button>
										</template>
									</div>
								</td>
								<td></td>
								<td></td>
							</tr>
							<tr>
								<!-- 참조처 -->
								<th>{{ getMessage_('QWCC001461') }}</th>
								<td class="col-2">
									<!-- <el-input
										:value="popupSearchParams.rfp"
										@input="value => setPopupSearchParams_({ key: 'rfp', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/> -->
									<el-input
										:value="this.detailForm.rfpNm"
										@input="value => setDetailForm({ key: 'rfpNm', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/>
									<span class="unit input-icon" @click="() => openUserPopup('rfp')" v-if="!setDisabled">
										<i class="icon-sf-search" />
									</span>
								</td>
								<td class="qms-apcn-tag" colspan="5">
									<div class="d-flex" style="text-align: left !important; overflow-x: auto; overflow-y: hidden">
										<el-tag
											:key="idx"
											v-for="(tag, idx) in rfpTag"
											:closable="!setDisabled"
											:disable-transitions="false"
											@close="handleClose(tag, idx, 'rfp')"
										>
											{{ tag }}
										</el-tag>
										<template v-if="!setDisabled">
											<el-input
												class="input-new-tag"
												v-if="rfpVisible"
												v-model="rfpValue"
												ref="saveRfpInput"
												size="mini"
												@keyup.enter.native="handleRfpInputConfirm"
												@blur="handleRfpInputConfirm"
											>
											</el-input>
											<el-button v-else class="button-new-tag" @click="showRfpInput">+ {{ getMessage_('QWCC001492') }}</el-button>
										</template>
									</div>
								</td>
								<td>{{ getAffrInfo_.writerNm }}</td>
								<td>{{ getAffrInfo_.csetNm }}</td>
							</tr>
							<tr>
								<!-- 참조처 -->
								<th>{{ getMessage_('QWCC001847') }}</th>
								<td class="col-2">
									<el-input
										:value="this.detailForm.rfpBcNm"
										@input="value => setDetailForm({ key: 'rfpBcNm', value })"
										class="inputWithIcon"
										:placeholder="getMessage_('QWCC001525')"
										:readonly="setDisabled"
									/>
									<span class="unit input-icon" @click="() => openUserPopup('rfpBc')" v-if="!setDisabled">
										<i class="icon-sf-search" />
									</span>
								</td>
								<td class="qms-apcn-tag" colspan="5">
									<div class="d-flex" style="text-align: left !important; overflow-x: auto; overflow-y: hidden">
										<el-tag
											:key="idx"
											v-for="(tag, idx) in rfpBcTag"
											:closable="!setDisabled"
											:disable-transitions="false"
											@close="handleClose(tag, idx, 'rfpBc')"
										>
											{{ tag }}
										</el-tag>
										<template v-if="!setDisabled">
											<el-input
												class="input-new-tag"
												v-if="rfpBcVisible"
												v-model="rfpBcValue"
												ref="saveRfpBcInput"
												size="mini"
												@keyup.enter.native="handleRfpBcInputConfirm"
												@blur="handleRfpBcInputConfirm"
											>
											</el-input>
											<el-button v-else class="button-new-tag" @click="showRfpBcInput">+ {{ getMessage_('QWCC001492') }}</el-button>
										</template>
									</div>
								</td>
								<td></td>
								<td></td>
							</tr>
							<tr>
								<!-- 발신처 -->
								<th>{{ getMessage_('QWCC000050') }}</th>
								<td class="col-2">
									<el-input
										:value="this.detailForm.dsprNm"
										:placeholder="getMessage_('QWCC001520')"
										@input="value => setDetailForm_({ key: 'dsprNm', value })"
										readonly
									/>
								</td>
								<td colspan="3">
									<el-input
										:value="this.detailForm.dsprAdr"
										:placeholder="getMessage_('QWCC001521')"
										@input="value => setDetailForm_({ key: 'dsprAdr', value })"
										@keyup.enter.native="checkEmail"
										@blur="checkEmail"
										readonly
									/>
								</td>
								<!-- 메일전송 -->
								<th>{{ getMessage_('QWCC001486') }}</th>
								<td>
									<sf-select-group
										labelPosition="left"
										:inputValue="detailForm.sndStCd"
										:options="detailForm.snStCd !== 'ET_FAIL' ? sndStList : getSndStListFiltered_"
										:onChange="val => setDetailForm(val, 'sndStCd')"
										:placeholder="getMessage_('QWCC001094')"
										:disabled="detailForm.snStCd !== 'ET_FAIL'"
									/>
								</td>
								<td>{{ getAffrInfo_.writeDd }}</td>
								<td>{{ getAffrInfo_.csetDd }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<user-popup :scrId="scrId" ref="userPopupRef" @SendData="closeUserPopup"></user-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';
import UserPopup from '@qms/comm/commpopup/UserEmailPopup/UserEmailPopupView.vue';

export default {
	data() {
		return {
			rcptMap: new Map(),
			rcptTag: new Array(),
			rcptTracker: 0,
			rcptVisible: false,
			rcptValue: '',

			rcptBcMap: new Map(),
			rcptBcTag: new Array(),
			rcptBcTracker: 0,
			rcptBcVisible: false,
			rcptBcValue: '',

			rfpMap: new Map(),
			rfpTag: new Array(),
			rfpTracker: 0,
			rfpVisible: false,
			rfpValue: '',

			rfpBcMap: new Map(),
			rfpBcTag: new Array(),
			rfpBcTracker: 0,
			rfpBcVisible: false,
			rfpBcValue: '',
		};
	},
	mounted() {
		this.setupEmail();
	},
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		UserPopup
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		setDisabled() {
			return this.detailForm.pgsStCd >= 40 ? true : false;
		}
	},
	watch: {
		rcptTracker() {
			this.setState_({ key: 'isSaved', value: true });
			this.setState_({ key: 'rcptInfo', value: this.rcptMap });
			if (this.rcptInfo.size > 0) {
				let rcptNm = '',
					rcptAdr = '';
				for (const [key, val] of this.rcptInfo) {
					rcptNm += val + ';';
					rcptAdr += key + ';';
				}
				this.setDetailForm({ key: 'rcptNm', value: rcptNm.substring(0, rcptNm.length - 1) });
				this.setDetailForm({ key: 'rcptAdr', value: rcptAdr.substring(0, rcptAdr.length - 1) });
			}
		},
		rcptBcTracker() {
			this.setState_({ key: 'isSaved', value: true });
			this.setState_({ key: 'rcptBcInfo', value: this.rcptBcMap });
			if (this.rcptBcInfo.size > 0) {
				let rcptBcNm = '',
				    rcptBcAdr = '';
				for (const [key, val] of this.rcptBcInfo) {
					rcptBcNm += val + ';';
					rcptBcAdr += key + ';';
				}
				this.setDetailForm({ key: 'rcptBcNm', value: rcptBcNm.substring(0, rcptBcNm.length - 1) });
				this.setDetailForm({ key: 'rcptBcAdr', value: rcptBcAdr.substring(0, rcptBcAdr.length - 1) });
			}
		},
		rfpTracker() {
			this.setState_({ key: 'isSaved', value: true });
			this.setState_({ key: 'rfpInfo', value: this.rfpMap });
			if (this.rfpInfo.size > 0) {
				let rfpNm = '',
					rfpAdr = '';
				for (const [key, val] of this.rfpInfo) {
					rfpNm += val + ';';
					rfpAdr += key + ';';
				}
				this.setDetailForm({ key: 'rfpNm', value: rfpNm.substring(0, rfpNm.length - 1) });
				this.setDetailForm({ key: 'rfpAdr', value: rfpAdr.substring(0, rfpAdr.length - 1) });
			}
		},
		rfpBcTracker() {
			this.setState_({ key: 'isSaved', value: true });
			this.setState_({ key: 'rfpBcInfo', value: this.rfpBcMap });
			if (this.rfpBcInfo.size > 0) {
				let rfpBcNm = '',
					rfpBcAdr = '';
				for (const [key, val] of this.rfpBcInfo) {
					rfpBcNm += val + ';';
					rfpBcAdr += key + ';';
				}
				this.setDetailForm({ key: 'rfpBcNm', value: rfpBcNm.substring(0, rfpBcNm.length - 1) });
				this.setDetailForm({ key: 'rfpBcAdr', value: rfpBcAdr.substring(0, rfpBcAdr.length - 1) });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setDetailForm(payload) {
			this.setState_({ key: 'isSaved', value: true });
			this.setDetailForm_(payload);
		},
		openUserPopup(userGbn) {
			this.$refs.userPopupRef.open({ userGbn, userName: this.popupSearchParams[userGbn] });
		},
		closeUserPopup(userList, gubun) {
			for (const user of userList) {
				if (user.email && !this[gubun + 'Map'].has(user.email)) {
					this[gubun + 'Map'].set(user.email, user.userName);
					this[gubun + 'Tag'].push(`<${user.userName}>${user.email}`);
					this[gubun + 'Tracker']++;
				}
			}
			this.setPopupSearchParams_({ key: gubun, value: '' });
		},
		handleClose(tag, idx, gubun) {
			this[gubun + 'Tag'].splice(idx, 1);
			this[gubun + 'Map'].delete(tag.split('>')[1]);
			this[gubun + 'Tracker']--;
		},

		showRcptInput() {
			this.rcptVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveRcptInput.$refs.input.focus();
			});
		},
		showRcptBcInput() {
			this.rcptBcVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveRcptBcInput.$refs.input.focus();
			});
		},
		showRfpInput() {
			this.rfpVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveRfpInput.$refs.input.focus();
			});
		},
		showRfpBcInput() {
			this.rfpBcVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveRfpBcInput.$refs.input.focus();
			});
		},
		handleRcptInputConfirm() {
			const rcptValue = this.rcptValue;
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!rcptValue) null;
			else if (regExp.test(rcptValue)) {
				this.rcptTag.push(rcptValue);
				this.rcptMap.set(rcptValue, rcptValue.split('@')[0]);
				this.rcptTracker++;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
			this.rcptVisible = false;
			this.rcptValue = '';
		},
		handleRcptBcInputConfirm() {
			const rcptBcValue = this.rcptBcValue;
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!rcptBcValue) null;
			else if (regExp.test(rcptBcValue)) {
				this.rcptBcTag.push(rcptBcValue);
				this.rcptBcMap.set(rcptBcValue, rcptBcValue.split('@')[0]);
				this.rcptBcTracker++;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
			this.rcptBcVisible = false;
			this.rcptBcValue = '';
		},
		handleRfpInputConfirm() {
			const rfpValue = this.rfpValue;
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!rfpValue) null;
			else if (regExp.test(rfpValue)) {
				this.rfpTag.push(rfpValue);
				this.rfpMap.set(rfpValue, rfpValue.split('@')[0]);
				this.rfpTracker++;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
			this.rfpVisible = false;
			this.rfpValue = '';
		},
		handleRfpBcInputConfirm() {
			const rfpBcValue = this.rfpBcValue;
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (!rfpBcValue) null;
			else if (regExp.test(rfpBcValue)) {
				this.rfpBcTag.push(rfpBcValue);
				this.rfpBcMap.set(rfpBcValue, rfpBcValue.split('@')[0]);
				this.rfpBcTracker++;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			}
			this.rfpBcVisible = false;
			this.rfpBcValue = '';
		},
		checkEmail() {
			const regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (this.detailForm.dsprAdr && !regExp.test(this.detailForm.dsprAdr)) {
				this.setDetailForm_({ key: 'dsprAdr', value: '' });
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001501') });
			} else this.setState_({ key: 'isSaved', value: true });
		},
		setupEmail() {
			this.initEmail();

			const dsprId = this.detailForm.dsprId || window.atob(this.user.userId);
			const dsprAdr = this.detailForm.dsprAdr || this.user.email;
			const dsprNm = this.detailForm.dsprNm || this.user.userName;

			this.setDetailForm_({ key: 'dsprId', value: dsprId });
			this.setDetailForm_({ key: 'dsprAdr', value: dsprAdr });
			this.setDetailForm_({ key: 'dsprNm', value: dsprNm });

			const rcptNms = this.detailForm.rcptNm && this.detailForm.rcptNm?.split(';');
			const rcptAdrs = this.detailForm.rcptAdr && this.detailForm.rcptAdr?.split(';');
			const rfpNms = this.detailForm.rfpNm && this.detailForm.rfpNm?.split(';');
			const rfpAdrs = this.detailForm.rfpAdr && this.detailForm.rfpAdr?.split(';');

			const rcptBcNms = this.detailForm.rcptBcNm && this.detailForm.rcptBcNm?.split(';');
			const rcptBcAdrs = this.detailForm.rcptBcAdr && this.detailForm.rcptBcAdr?.split(';');
			const rfpBcNms = this.detailForm.rfpBcNm && this.detailForm.rfpBcNm?.split(';');
			const rfpBcAdrs = this.detailForm.rfpBcAdr && this.detailForm.rfpBcAdr?.split(';');

			if (rcptAdrs?.length) {
				const rcptArrNew = [],
					rcptMapNew = new Map();
				for (let i = 0; i < rcptAdrs.length; i++) {
					rcptArrNew.push(`<${rcptNms[i]}>${rcptAdrs[i]}`);
					rcptMapNew.set(rcptAdrs[i], rcptNms[i]);
				}
				this.setState_({ key: 'rcptInfo', value: rcptMapNew });
				this.rcptTag = rcptArrNew;
				this.rcptMap = rcptMapNew;
			}
			if (rcptBcAdrs?.length) {
				const rcptBcArrNew = [],
					rcptBcMapNew = new Map();
				for (let i = 0; i < rcptBcAdrs.length; i++) {
					rcptBcArrNew.push(`<${rcptBcNms[i]}>${rcptBcAdrs[i]}`);
					rcptBcMapNew.set(rcptBcAdrs[i], rcptBcNms[i]);
				}
				this.setState_({ key: 'rcptBcInfo', value: rcptBcMapNew });
				this.rcptBcTag = rcptBcArrNew;
				this.rcptBcMap = rcptBcMapNew;
			}

			if (rfpAdrs?.length) {
				const rfpArrNew = [],
					rfpMapNew = new Map();

				for (let i = 0; i < rfpAdrs.length; i++) {
					rfpArrNew.push(`<${rfpNms[i]}>${rfpAdrs[i]}`);
					rfpMapNew.set(rfpAdrs[i], rfpNms[i]);
				}

				this.setState_({ key: 'rfpInfo', value: rfpMapNew });
				this.rfpMap = rfpMapNew;
				this.rfpTag = rfpArrNew;
			}
			if (rfpBcAdrs?.length) {
				const rfpBcArrNew = [],
					rfpBcMapNew = new Map();

				for (let i = 0; i < rfpBcAdrs.length; i++) {
					rfpBcArrNew.push(`<${rfpBcNms[i]}>${rfpBcAdrs[i]}`);
					rfpBcMapNew.set(rfpBcAdrs[i], rfpBcNms[i]);
				}

				this.setState_({ key: 'rfpBcInfo', value: rfpBcMapNew });
				this.rfpBcMap = rfpBcMapNew;
				this.rfpBcTag = rfpBcArrNew;
			}
		},
		//이메일 초기화 ref 식으로 부모창에서 써보세요 예시 : 같은 폴더 바로 위 Popup.vue에 있음
		initEmail() {
			this.rcptMap = new Map();
			this.rcptTag = new Array();
			this.rcptTracker = 0;
			this.rcptVisible = false;
			this.rcptValue = '';
			this.rfpMap = new Map();
			this.rfpTag = new Array();
			this.rfpTracker = 0;
			this.rfpVisible = false;
			this.rfpValue = '';

			this.rcptBcMap = new Map();
			this.rcptBcTag = new Array();
			this.rcptBcTracker = 0;
			this.rcptBcVisible = false;
			this.rcptBcValue = '';
			this.rfpBcMap = new Map();
			this.rfpBcTag = new Array();
			this.rfpBcTracker = 0;
			this.rfpBcVisible = false;
			this.rfpBcValue = '';
		}
	}
};
</script>

<style lang="scss">
.qms-apcn-tag {
	::-webkit-scrollbar {
		height: 5px !important;
	}
}
.el-tag {
	height: 30px !important;
	line-height: 30px !important;
	margin-left: 5px !important;
}
.el-tag + .el-tag {
	margin-left: 5px !important;
}
.button-new-tag {
	margin-left: 5px !important;
	min-height: 30px !important;
	width: auto !important;
	height: 30px !important;
	line-height: 30px !important;
	padding: 3px 15px !important;
	font-size: 12px !important;
	display: inline-block !important;
	border-radius: 4px !important;
}
.input-new-tag {
	width: 350px !important;
	min-width: 350px !important;
	margin-left: 5px !important;
	vertical-align: bottom;
}
</style>
